'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reduxForm = require('redux-form');

var _zendesk = require('../../redux/modules/zendesk');

var _EditAppPopup = require('@quixeltools/quixel-ui-library/dist/components/megascans/account/EditAppPopup');

var _EditAppPopup2 = _interopRequireDefault(_EditAppPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditAppPopupContainer = function (_React$Component) {
  (0, _inherits3.default)(EditAppPopupContainer, _React$Component);

  function EditAppPopupContainer(props) {
    (0, _classCallCheck3.default)(this, EditAppPopupContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (EditAppPopupContainer.__proto__ || (0, _getPrototypeOf2.default)(EditAppPopupContainer)).call(this, props));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(EditAppPopupContainer, [{
    key: 'onCloseClick',
    value: function onCloseClick() {
      this.props.onCloseYes();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          name = _props.name,
          icon = _props.icon,
          secret = _props.secret,
          company = _props.company,
          description = _props.description,
          childReference = _props.childReference;


      return _react2.default.createElement(_EditAppPopup2.default, {
        icon: '/quixel_2080_logo.png',
        title: name,
        description: 'View the details of your app here.',

        id: id,
        secret: secret,
        company: company,
        iconUrl: icon,
        appDescription: description,

        onCancelClick: this.onCloseClick.bind(this),
        onChildRef: childReference
      });
    }
  }]);
  return EditAppPopupContainer;
}(_react2.default.Component);

exports.default = EditAppPopupContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/EditAppContainer/EditAppContainer.jsx
// module id = 2799
// module chunks = 0